import InputField from "../InputField/InputField";
import "../../pages/ProfileSettings/SetupProfile.css";
import pic from "../../pages/ProfileSettings/Logo.jpg";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { Link } from "react-router-dom";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { SkillsArray, GenresArray } from "../../components/constants";
import { SelectField } from "../../pages/ProfileSettings/types";
import { Backdrop, IconButton } from "@mui/material";
import { submitButtonStyle } from "../../pages/ProfileSettings/styles";
import { useStyles } from "../../pages/ProfileSettings/styles";
import { LightTooltip } from "../../components/LightToolTip/LightToolTip";
import { SetupProfileMainSettingsProps } from "./types";
import { styles } from "./styles";
import { FONT_FAMILY } from "../../theme";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const SetupProfileMainSettings: React.FC<
  SetupProfileMainSettingsProps
> = ({
  errorFirstName,
  profile,
  handleChange,
  setErrorFirstName,
  errorFirstNameEmpty,
  errorLastName,
  setErrorLastName,
  errorLastNameEmpty,
  handleChangeSkill,
  handleChangeGenre,
  profilePic,
  onImageClick,
  profilePicture,
  onInputChange,
  handleSubmit,
  isLoading,
  errorUsername,
  duplicateUsername,
  setErrorUsername,
  setDuplicateUsername,
  errorUsernameEmpty,
  isAuthenticated,
  user,
  isChecked,
  handleCheckboxChange,
}) => {
  const classes = useStyles();
  return (
    <>
      <div className="container">
        <Backdrop
          open={isLoading}
          invisible={false}
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <CircularProgress color="primary" />
        </Backdrop>
        <h1 className="settings-header">{"Let's setup your OmMuse profile"}</h1>
        <div className="form-body-settings">
          <div className="row-one">
            <InputField
              error={errorFirstName && true}
              label="first Name"
              placeholder="First Name"
              value={profile.firstName}
              onchange={handleChange}
              type="text"
              onFocus={() => setErrorFirstName(false)}
              required
              isEmpty={errorFirstNameEmpty}
            />
            <InputField
              error={errorLastName && true}
              label="last Name"
              placeholder="Last Name"
              value={profile.lastName}
              onchange={handleChange}
              type="text"
              onFocus={() => setErrorLastName(false)}
              required
              isEmpty={errorLastNameEmpty}
            />
            <InputField
              error={(errorUsername && true) || (duplicateUsername && true)}
              value={profile.username}
              label="username (stage name)"
              placeholder="Username"
              onchange={handleChange}
              type="text"
              onFocus={() => {
                setErrorUsername(false);
                setDuplicateUsername(false);
              }}
              required
              usernameError={duplicateUsername}
              isEmpty={errorUsernameEmpty}
            />
            <InputField
              label="email"
              value={isAuthenticated ? user?.email ?? "" : "Email"}
              onchange={handleChange}
              type="email"
              disabled={true}
              required
            />
          </div>

          <div className="row-one">
            <label htmlFor="bio" className="label__input">
              Bio
              <LightTooltip
                title="Emails and URLs will be extracted and linked"
                enterTouchDelay={0}
                enterDelay={300}
              >
                <IconButton disableRipple>
                  <HelpOutlineIcon
                    color="info"
                    style={{ height: 16, width: 16 }}
                  />
                </IconButton>
              </LightTooltip>
            </label>
            <TextField
              inputProps={{ style: { fontFamily: "Argumentum" } }}
              multiline
              rows={5}
              variant="outlined"
              name="bio"
              id="bio"
              className="bio_input"
              onChange={handleChange}
              sx={styles.textArea}
            />
          </div>

          <div className="row-one">
            <label htmlFor="bio" className="label__input">
              Skills
            </label>

            <Stack spacing={3}>
              <SelectField
                multiple
                style={{ width: "92%" }}
                id="checkboxes-tags-demo"
                options={SkillsArray}
                disableCloseOnSelect
                onChange={(e, v) => handleChangeSkill(e, v)}
                renderOption={(props, option, { selected }) => (
                  <li
                    {...props}
                    style={{
                      fontFamily: FONT_FAMILY,
                    }}
                  >
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label=" "
                    InputLabelProps={{ shrink: false }}
                    classes={{ root: classes.customTextField }}
                  />
                )}
              />
            </Stack>
          </div>

          <div className="row-one">
            <label htmlFor="bio" className="label__input">
              Genres
            </label>

            <Stack spacing={3}>
              <SelectField
                multiple
                style={styles.genreSelectField}
                id="checkboxes-tags-demo"
                options={GenresArray}
                disableCloseOnSelect
                onChange={(e, v) => handleChangeGenre(e, v)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={styles.genreLiTag}>
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={styles.genreCheckBox}
                        checked={selected}
                      />
                      {option}
                    </>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    sx={{ color: "white" }}
                    {...params}
                    label=" "
                    InputLabelProps={{ shrink: false }}
                    classes={{ root: classes.customTextField }}
                  />
                )}
              />
            </Stack>
          </div>

          <div className="row-one">
            <label htmlFor={"image"} className="label__input">
              Profile Picture
            </label>

            <div className="profile-pic">
              <img
                src={profilePic ? profilePic : pic}
                alt="profilepic"
                className="profile-image"
                onClick={onImageClick}
              />
            </div>
            <input
              type="file"
              id={"image"}
              name={"profilePic"}
              className="input__file"
              ref={profilePicture}
              accept="image/*"
              multiple={false}
              style={{ display: "none" }}
              onChange={onInputChange}
            />
            <p style={{ color: "white" }} className="prof-img-sub">
              Click the image to upload
            </p>
          </div>
          <hr style={{ marginRight: 10 }} />
          <div style={styles.privacyPolicyContainer}>
            <input
              className="checkbox-mint"
              type="checkbox"
              checked={isChecked}
              style={{ marginRight: 10 }}
              onChange={handleCheckboxChange}
            />
            <span style={{ fontFamily: FONT_FAMILY }}>
              By signing up you agree to{" "}
              <Link
                style={{ textDecoration: "none" }}
                to="/terms-of-use"
                target="_blank"
              >
                Terms of Use
              </Link>
              ,{" "}
              <Link
                style={{ textDecoration: "none" }}
                to="/creator-agreement"
                target="_blank"
              >
                Creator Agreement
              </Link>
              , and{" "}
              <Link
                style={{ textDecoration: "none" }}
                to="/privacy-policy"
                target="_blank"
              >
                Privacy Policy
              </Link>
            </span>
          </div>

          <div className="btn-center">
            <Button
              onClick={handleSubmit}
              color="secondary"
              sx={submitButtonStyle}
              disabled={!isChecked}
              size="medium"
              variant="contained"
            >
              Save Changes
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
